import React, { useRef, memo } from 'react';

const FormPreventEnterSubmitComponent = ({ children, onSubmit, ...rest }) => {
  const enterHit = useRef(false);

  const handleKeyPress = event => {
    enterHit.current = event.key === 'Enter';
  };

  const handleOnSubmit = event => {
    event.preventDefault();
    if (!enterHit.current && onSubmit) {
      onSubmit(event);
    }
  };

  return (
    <form {...rest} onKeyPress={handleKeyPress} onSubmit={handleOnSubmit}>
      {children}
    </form>
  );
};

export const FormPreventEnterSubmit = memo(FormPreventEnterSubmitComponent);
